// view-mode.enum.ts
export enum ViewMode {
    TABBED = 'TABBED',
    ACCORDION = 'ACCORDION',
  }
  